export const DEFAULT_PAGE_INDEX = 1
export const DEFAULT_PAGE_SIZE = 10
export const DEFAULT_PAGE_SIZE_MAX = 500
export const DEFAULT_PAGE_OPTIONS = [10, 20, 50, 100]
export const IMPORT_WHITELIST_VESTING = 20000
